import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Container } from 'reactstrap';
import { Link, withRouter } from 'react-router-dom';
import { withNamespaces } from 'react-i18next';

import Loader from '../../components/Common/Loader';
import PlcSafetyZoneDependencyList from '../../components/Lists/PlcSafetyZoneDependencyList';
import { getPlcSafetyZoneDependencies } from '../../store/actions';

class PlcSafetyZoneDependencies extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem('authUser')),
      zoneDependencyList: null,
    };
  }

  componentDidMount() {
    this.props.getPlcSafetyZoneDependencies(this.state.user);
  }

  componentDidUpdate(prevProps) {
    if (this.props.zoneDependencies !== prevProps.zoneDependencies) {
      this.setState({ zoneDependencyList: this.props.zoneDependencies });
    }
  }

  refresh(event) {
    event.preventDefault();
    this.setState({ zoneDependencyList: null });
    this.props.getPlcSafetyZoneDependencies(this.state.user);
  }

  render() {
    if (!this.state.zoneDependencyList) {
      return (
        <div className="loaderCenter">
          <Loader></Loader>
        </div>
      );
    }
    return (
      <div className="user-management">
        <Container fluid>
          <Button
            onClick={(event) => this.refresh(event)}
            color="primary"
            className="btn btn-primary buttonStatus usersButtons"
          >
            <i size="lg" className="mdi mdi-refresh"></i>
          </Button>
          <Button className="btn btn-primary waves-effect waves-light buttonStatus usersButtons">
            <Link to="/createPlcSafetyZoneDependency">{this.props.t('Crear dependencia')}</Link>
          </Button>
          <Button className="btn btn-secondary waves-effect waves-light buttonStatus usersButtons">
            <Link to="/plcSafetyEvents">{this.props.t('Ver eventos')}</Link>
          </Button>
          <PlcSafetyZoneDependencyList zoneDependencyList={this.state.zoneDependencyList} />
        </Container>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { zoneDependencies } = state.getPlcSafetyZoneDependencies;
  return { zoneDependencies };
};

export default withRouter(
  connect(mapStateToProps, { getPlcSafetyZoneDependencies })(withNamespaces()(PlcSafetyZoneDependencies)),
);
